import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import CustomInput from "../../../shared/components/CustomInput";
import s from "../styles.module.css";
import logo from "../../../shared/assets/img/logo.png";
import { toast } from "react-toastify";
import useAuth from "../../../hooks/useAuth";
import { useEffect } from "react";
import axios from "../../../api/axios";

const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setAuth } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const API_URL = process.env.REACT_APP_API_URL;
  const LOGIN_URL = API_URL + "/api/v1/agents/login";

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(LOGIN_URL, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      const access_token = response?.data?.access_token;
      const agent_id = response?.data?.agent_id;
      const role = response?.data?.role;
      const email = data.email;
      const password = data.password;
      const isAuthenticated = true;

      setAuth({
        email,
        password,
        access_token,
        agent_id,
        role,
        isAuthenticated,
      });
      navigate("/myProperties");
    } catch (error) {
      toast.error(error);
      console.error("Ошибка при входе:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className={s.loginPage}>
        <form onSubmit={handleSubmit(onSubmit)} className={s.form}>
          <img src={logo} alt="logo" />
          <div className={s.box}>
            <div className={s.inputWrapper}>
              <CustomInput
                name="email"
                label="Email"
                placeholder="Введите логин"
                type="text"
                error={!!errors.email}
                helperText={errors.email?.message || ""}
                inputRef={
                  register("email", {
                    required: "Логин обязателен",
                  }).ref
                }
                {...register("email", {
                  required: "Логин обязателен",
                })}
              />
            </div>
            <div className={s.inputWrapper}>
              <CustomInput
                name="password"
                label="Пароль"
                placeholder="Введите пароль"
                type="password"
                error={!!errors.password}
                helperText={errors.password?.message || ""}
                inputRef={
                  register("password", {
                    required: "Пароль обязателен",
                  }).ref
                }
                {...register("password", {
                  required: "Пароль обязателен",
                })}
              />
            </div>
          </div>

          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <div className="loader"></div>
            </div>
          ) : (
            <button type="submit" className={s.btn}>
              Войти
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
